export const formatTrackedDuration = seconds => {
  const total = Math.max(0, Number(seconds) || 0);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  }
  return `${secs}s`;
};

export const isRunningTimeEntry = entry => {
  if (!entry) return false;
  if (entry.is_running) return true;
  return !entry.stopped_at && !entry.is_manual && (entry.seconds === null || entry.seconds === undefined);
};

export const timeEntryDurationLabel = entry => {
  if (isRunningTimeEntry(entry)) {
    return `Em andamento · ${formatTrackedDuration(entry?.elapsed_seconds)}`;
  }
  return formatTrackedDuration(entry?.seconds);
};
